import { loanPurposeTypes, subjectPropertyTypes } from '../../../cmg-1003/models';
import { states } from '../../../cmg-1003/models/lookups/common.lookups';
import { PropertyInformationModel } from '../../../cmg-1003/models/property-information.model';
import { IdValue } from '../../../shared/models/id-value.model';
import { occupancyTypes } from '../../utils';

export const findMatchingCountyId = (counties: IdValue<string>[], countyName: string) => {
  return counties.filter((county) => county.name.toLowerCase() === countyName.toLowerCase())[0]?.id;
};

/** Generates values that are derived from other values about the property and/or borrower(s). */
export const generateDerivedValues = (propertyInfo: PropertyInformationModel, occupancyType: number) => {
  return <Partial<PropertyInformationModel>>{
    occupancyType: occupancyType,
    grossRentalIncome: propertyInfo.grossRentalIncome,
    vacancyFactor: !propertyInfo.vacancyFactor ? 25 : propertyInfo.vacancyFactor,
  };
};

export const assembleLookups = () => {
  return {
    states: states.filter((state) => !['AS', 'MP'].includes(state.id)),
    counties: [] as IdValue<string>[],
    loanPurposes: loanPurposeTypes,
    occupancyTypes: occupancyTypes,
    propertyTypes: subjectPropertyTypes,
  };
};

export const generateDerivedStreetValue = (propertyInfo: PropertyInformationModel) => {
  return <Partial<PropertyInformationModel>>{
    unitNumber: propertyInfo?.unitNumber?.trim(),
    streetforUI: propertyInfo?.street?.trim(),
  };
};
